import { Box, Icon } from '@hover/blueprint';
import { iconUser } from '@hover/icons';
import React from 'react';

import { getInitialsFromName } from 'src/shared/utils/initials';

export const UserIcon = ({ name }: { name: string | null | undefined }) =>
  name?.length ? (
    <Box
      alignItems="center"
      backgroundColor="neutral.50"
      borderRadius="50%"
      fontWeight="bold"
      height={400}
      justifyContent="center"
      padding={200}
      textAlign="center"
      width={400}
    >
      {getInitialsFromName(name)}
    </Box>
  ) : (
    <Icon color="neutral.900" icon={iconUser} size="medium" />
  );
